import script from "./EmployeeAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeAvatar.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeAvatar.vue?vue&type=style&index=0&id=bbdb9474&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbdb9474"]])

export default __exports__